import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { SolutionsHero, HubSpoke, MarketContext, ServiceBlocks, IndustriesMatrix } from '../components/sections/solutions';
import { FinalCTA } from '../components/sections/home';
import { RelatedPages } from '../components/RelatedPages';
import styles from './Solutions.module.css';

export function Solutions() {
  const { t } = useTranslation('solutions');

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />

      <div className={styles.aboveFold}>
        <div className={styles.aboveFoldBg} />
        <SolutionsHero />
        <HubSpoke />
        <div className={styles.scrollIndicator} aria-hidden="true">
          <div className={styles.chevron} />
          <div className={styles.chevron} />
          <div className={styles.chevron} />
        </div>
      </div>

      <IndustriesMatrix />
      <ServiceBlocks />
      <MarketContext />

      <RelatedPages currentFrPath="/solutions" />
      <FinalCTA />
    </>
  );
}
